// Validates that a URL uses the HTTPS protocol.
// Prevents open-redirect attacks where portal.kentik.com could be used as a
// trusted-domain redirector to an arbitrary attacker-controlled URL.
const httpsUrl = {
  message: 'The :attribute must be a valid HTTPS URL with a hostname',
  fn: (value) => {
    if (!value) {
      return true;
    }
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && !!url.hostname && !url.username && !url.password;
    } catch {
      return false;
    }
  }
};

export default httpsUrl;
